import React from 'react';

const GoogleMeet = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d="m10 5-8 8.08 4 2.502 4-2.501 2.259-4.04L10 5Z" fill="#FF2820" />
        <path d="M10 13.08H2v10.506l4 2.219 4-2.22V13.082Z" fill="#0084FF" />
        <path
            d="M2 23.586v5.387c0 1.482 1.2 2.694 2.667 2.694H10l2.259-4.29L10 23.586H2Z"
            fill="#06D"
        />
        <path
            d="m32.348 7.869-4.948 3.96v.04l-1.614 6.223 1.614 6.297 4.926 4.005c.66.56 1.674.09 1.674-.785V8.653c0-.874-.991-1.344-1.652-.784Z"
            fill="#00AD3C"
        />
        <path
            d="M27.4 11.828V7.663C27.4 6.198 26.226 5 24.79 5H10v8.08h9.8v5.253l5.265-.592 2.335-5.913Z"
            fill="#FFBA00"
        />
        <path
            d="M19.8 23.586H10v8.08h14.79c1.436 0 2.61-1.196 2.61-2.658v-4.614l-2.612-5.42-4.988-.64v5.252Z"
            fill="#00AD3C"
        />
        <path d="m19.8 18.333 7.6 6.06V11.829l-7.6 6.505Z" fill="#00831E" />
    </svg>
);

export default GoogleMeet;